import { render, staticRenderFns } from "./status-update.vue?vue&type=template&id=33284d2c&"
import script from "./status-update.vue?vue&type=script&lang=js&"
export * from "./status-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports